import { useEffect, useState } from 'react';

import { Button, InputNumber, message } from 'antd';
import { T } from 'react-translator-component';

import { getPushConfig, updatePushConfig } from '../../hooks/settings';

const PushLimitConfigForm = () => {
  const [limit, setLimit] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    // getPushConfig uses getDocuments, which returns data directly (no .data wrapper).
    // Evidence: getPushNotificationHistory (same getDocuments) is read as data?.results, data?.count — no .data nesting.
    getPushConfig()
      .then((r) => setLimit(r?.maxUsersPerPush ?? 500))
      .catch(() => message.error(T('Erro ao carregar configuração de push')));
  }, []);

  const save = async () => {
    if (!limit || limit < 1) {
      message.warning(T('Informe um valor maior ou igual a 1'));
      return;
    }
    setSaving(true);
    try {
      // updatePushConfig uses updateDocumentByPath (mutation helper) — returns { type, data }.
      // Evidence: sendPushNotification/retryPushNotification checked as `data !== null && data.type === 'success'`.
      const r = await updatePushConfig(limit);
      if (r !== null && r.type === 'success') {
        message.success(T('Limite atualizado com sucesso!'));
      } else {
        message.error(T('Não foi possível atualizar o limite.'));
      }
    } catch {
      message.error(T('Não foi possível atualizar o limite.'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ display: 'flex', gap: 12, alignItems: 'center', margin: '12px 0' }}>
      <span>{T('Limite de destinatários por push')}:</span>
      <InputNumber min={1} value={limit} onChange={setLimit} />
      <Button type='primary' loading={saving} onClick={save}>
        {T('Salvar')}
      </Button>
    </div>
  );
};

export default PushLimitConfigForm;
